function openTabFeed(triggerEl, sectionId, tabName) {
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(tabName).style.display = "block";
  if (triggerEl) {
    triggerEl.className += " active";
  }

  updateFeaturedTabButtonHref(sectionId, triggerEl?.dataset?.tabLink || "");
}

function updateFeaturedTabButtonHref(sectionId, tabLink) {
  const sectionRoot = document.querySelector(
    `.section-featured-products[data-section-id="${sectionId}"]`
  );
  if (!sectionRoot) return;

  const button = sectionRoot.querySelector("[data-featured-tab-button]");
  if (!button) return;

  const defaultHref = button.dataset.defaultHref || button.getAttribute("href") || "";
  const nextHref = tabLink || defaultHref;

  if (nextHref) {
    button.setAttribute("href", nextHref);
  }
}

function initFeaturedProductTabs(scope = document) {
  const sections = scope.querySelectorAll?.(".section-featured-products[data-section-id]") || [];

  sections.forEach((sectionEl) => {
    const defaultTabButton =
      sectionEl.querySelector("[data-default-open]") ||
      sectionEl.querySelector('button[class*="products-feed__tablinks--"]');

    if (defaultTabButton) {
      defaultTabButton.click();
    }
  });
}

// show first tab per section on load
initFeaturedProductTabs();

window.addEventListener("shopify:section:load", (event) => {
  initFeaturedProductTabs(event?.target || document);
});
